/* eslint-disable */

import * as SchemaTypes from '@freelancerepublik/graphql-types';

import { gql } from '@freelancerepublik/graphql-vue-apollo-patch';
import { createMutationFunction, createSmartQueryOptionsFunction, createSmartSubscriptionOptionsFunction } from 'vue-apollo-smart-ops';
import { ApolloError } from '@apollo/client';
export type AddressFragmentAgainFragment = { __typename?: 'Address', city?: string | null, country: string, region?: string | null, value: string, latlng?: { __typename?: 'Latlng', lat: number, lng: number } | null };

export type LoggedUserQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type LoggedUserQuery = { __typename?: 'Query', loggedUser?: { __typename?: 'User', _id?: string | null, auth0Id?: string | null, avatar?: string | null, createdAt: any, email?: any | null, firstname: string, fullname: string, gender?: SchemaTypes.Gender | null, lastname: string, lastLoginAt?: any | null, linkedinUrl?: string | null, prospectToken?: string | null, roles: Array<SchemaTypes.Role>, tel?: string | null, termsList: Array<any>, title: string, company: { __typename?: 'Company', activity?: string | null, capital?: number | null, form?: string | null, name?: string | null, rcs?: string | null, siret?: string | null, tva?: string | null, address?: { __typename?: 'Address', city?: string | null, country: string, region?: string | null, value: string, latlng?: { __typename?: 'Latlng', lat: number, lng: number } | null } | null }, freelance?: { __typename?: 'Freelance', source: SchemaTypes.FreelanceImportSourceEnum, expectedContract: SchemaTypes.ExpectedContract, activity?: SchemaTypes.Activity | null, jobCategories?: Array<string> | null, birthday?: any | null, description?: string | null, location: string, timing?: SchemaTypes.Timing | null, status: SchemaTypes.FreelanceStatus, skills: Array<string>, externalDocuments: Array<{ __typename?: 'ExternalDocument', id: string, name: string, url: string, updatedAt: any, createdAt: any }>, educations: Array<{ __typename?: 'Education', id: string, description?: string | null, institution: string, name: string, year?: number | null }>, geographicAvailability?: { __typename?: 'GeographicAvailability', address?: { __typename?: 'Address', city?: string | null, country: string, region?: string | null, value: string, latlng?: { __typename?: 'Latlng', lat: number, lng: number } | null } | null, mobility?: Array<{ __typename?: 'Address', city?: string | null, country: string, region?: string | null, value: string, latlng?: { __typename?: 'Latlng', lat: number, lng: number } | null }> | null, houseMove?: Array<{ __typename?: 'Address', city?: string | null, country: string, region?: string | null, value: string, latlng?: { __typename?: 'Latlng', lat: number, lng: number } | null }> | null } | null, resume?: { __typename?: 'Resume', url: string, updatedAt: any, parsedAt?: any | null } | null, keySkills: Array<{ __typename?: 'FreelanceKeySkill', name: string, description: string }>, experiences: Array<{ __typename?: 'Experience', id: string, actual: boolean, description?: string | null, startDate?: any | null, endDate?: any | null, job: string, location?: string | null, name: string }>, price?: { __typename?: 'FreelancePrice', target?: number | null } | null, salary?: { __typename?: 'FreelanceSalary', target?: number | null } | null, marketSituation?: { __typename?: 'MarketSituation', isListening: boolean, availableAt?: any | null, author?: { __typename?: 'User', _id?: string | null, fullname: string, avatar?: string | null } | null } | null, recommendations: Array<{ __typename?: 'Recommendation', id: string, companyName: string, contactEmail: string, contactJobTitle?: string | null, contactName: string, experienceEndDate?: any | null, experienceTitle: string, experienceStartDate: any, createdAt: any, updatedAt?: any | null }> } | null, referee?: { __typename?: 'User', _id?: string | null, avatar?: string | null, email?: any | null, firstname: string, lastname: string, fullname: string, tel?: string | null, title: string } | null, signatory: { __typename?: 'Signatory', gender?: string | null, email?: any | null, firstname?: string | null, lastname?: string | null, tel?: string | null, title?: string | null }, team?: Array<{ __typename?: 'User', _id?: string | null, fullname: string }> | null } | null };

export const AddressFragmentAgainFragmentDoc = gql`
    fragment addressFragmentAgain on Address {
  city
  country
  latlng {
    lat
    lng
  }
  region
  value
}
    `;
export const LoggedUserDocument = gql`
    query loggedUser {
  loggedUser {
    _id
    auth0Id
    avatar
    company {
      activity
      address {
        ...addressFragmentAgain
      }
      capital
      form
      name
      rcs
      siret
      tva
    }
    createdAt
    email
    firstname
    freelance {
      source
      expectedContract
      externalDocuments {
        id
        name
        url
        updatedAt
        createdAt
      }
      educations {
        id
        description
        institution
        name
        year
      }
      activity
      jobCategories
      geographicAvailability {
        address {
          ...addressFragmentAgain
        }
        mobility {
          ...addressFragmentAgain
        }
        houseMove {
          ...addressFragmentAgain
        }
      }
      birthday
      description
      location
      resume {
        url
        updatedAt
        parsedAt
      }
      timing
      keySkills {
        name
        description
      }
      status
      skills
      experiences {
        id
        actual
        description
        startDate
        endDate
        job
        location
        name
      }
      price {
        target
      }
      salary {
        target
      }
      marketSituation {
        isListening
        availableAt
        author {
          _id
          fullname
          avatar
        }
      }
      recommendations {
        id
        companyName
        contactEmail
        contactJobTitle
        contactName
        experienceEndDate
        experienceTitle
        experienceStartDate
        createdAt
        updatedAt
      }
    }
    fullname
    gender
    lastname
    lastLoginAt
    linkedinUrl
    prospectToken
    referee {
      _id
      avatar
      email
      firstname
      lastname
      fullname
      tel
      title
    }
    roles
    signatory {
      gender
      email
      firstname
      lastname
      tel
      title
    }
    tel
    termsList
    title
    team {
      _id
      fullname
    }
  }
}
    ${AddressFragmentAgainFragmentDoc}`;

/**
 * __useLoggedUserQuery__
 *
 * To use a Smart Query within a Vue component, call `useLoggedUserQuery` as the value for a query key
 * in the component's `apollo` config, passing any options required for the query.
 *
 * @param options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.query
 *
 * @example
 * {
 *   apollo: {
 *     loggedUser: useLoggedUserQuery({
 *       variables: {},
 *       loadingKey: 'loading',
 *       fetchPolicy: 'no-cache',
 *     }),
 *   }
 * }
 */
export const useLoggedUserQuery = createSmartQueryOptionsFunction<
  LoggedUserQuery,
  LoggedUserQueryVariables,
  ApolloError
>(LoggedUserDocument);
